import { createSlice } from '@reduxjs/toolkit'
import { userLoggedOut } from 'core/session/slices/session'
import { SimulatorSheetState } from './types'

const initialState: SimulatorSheetState = {}

const simulatorSheetSlice = createSlice({
  name: 'simulatorTrainingInstructorILSimulatorSheet',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

export default simulatorSheetSlice.reducer
